import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const IsleofMan: Country = {
    identifier: "IsleofMan",
    name: "Isle of Man",
    countryCode: "IM",
    group: CountryGroup.EUROPE,
    isUNMember: false,
    flag: "🇮🇲",
    svgPath: "m 462.51275,282.1414 -0.567,0.605 -0.23,-0.108 -0.196,0.057 -0.054,-0.017 0.111,-0.219 0.132,-0.507 0.235,-0.201 0.298,-0.528 0.236,-0.146 0.081,0.02 0.052,0.05 0.11,0.593 -0.152,0.209 z",
}
